export const PORTFOLIO_PROPERTY_FINDALL_REQUEST =
  'Portfolio/PROPERTY_FINDALL_REQUEST';
export const PORTFOLIO_PROPERTY_FINDALL_SUCCESS =
  'Portfolio/PROPERTY_FINDALL_SUCCESS';
export const PORTFOLIO_PROPERTY_FINDALL_ERROR =
  'Portfolio/PROPERTY_FINDALL_ERROR';
